<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-shopping</v-icon>Adicionar
          produto
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-select
              v-model="productName"
              :rules="nameRules"
              label="Categoria"
              required
              item-value="id"
              item-text="categoryServiceName"
              :items="getCategoryInCache"
              filled
            ></v-select>
            <!--              [{"serviceCategoryID":1,"categoryServiceUUID":"yewr83r43rbfu328r","categoryServiceName":"Telecomunicações"},{"serviceCategoryID":2,"categoryServiceUUID":"ercewg4y3gr4","categoryServiceName":"Serviços Públicos"},{"serviceCategoryID":3,"categoryServiceUUID":"765hg937kfhtwri3r","categoryServiceName":"Pagamento ao Estado"},{"serviceCategoryID":4,"categoryServiceUUID":"765qmd2df3fhtwri3r","categoryServiceName":"Educação e Ensino"}]-->
            <v-text-field
              v-model="productName"
              :rules="nameRules"
              label="Nome do produto"
              required
              filled
            ></v-text-field>

            <v-text-field
              v-model="productPrice"
              :rules="priceRules"
              label="Preço do produto"
              required
              filled
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="deep-purple lighten-2"
                text
                block
                @click="
                  {
                  }
                "
                :disabled="!valid"
                :loading="loading"
              >
                Adicionar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelperEnterprise } from "../../../../store/helperEnterprise";

export default {
  name: "OpenAddProduct",
  data: () => ({
    newPassword: "",
    repeatPassword: "",
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    pwdRules: [
      v => !!v || "Palavra-passe é requerida",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter",
      v =>
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) ||
        "Deve ter minúsculas, maísculas e caracter especial"
    ]
  }),
  created() {
    const self = this;
    eventBus.$on("openAddProduct", function(value) {
      self.dialog = value;
      // self.newPassword = "";
      // self.repeatPassword = "";
    });
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
